// extracted by mini-css-extract-plugin
module.exports = {"root":"radio_root__qCK_C"};